import React, { useContext } from 'react';
import 'Global/Styles/style.scss';
import 'Global/Styles/GenericColorDesign.scss';
import useCheckApiTokenExpiry from 'Global/Hooks/useCheckApiTokenExpiry';
import { GlobalContext } from 'Global/Context/GlobalContextProvider';
import useCheckUserPrefrences from 'Global/Hooks/useCheckUserPrefrences';
import useCheckOnLoginOperations from 'Global/Hooks/useCheckOnLoginOperations';
import useGetMainConfig from 'Global/Hooks/useGetMainConfig';
import useCacheIcons from 'Global/Hooks/useCacheIcons/useCacheIcons';
import NormalRouting from './NormalRouting';
import useCheckScreenWidth from 'Global/Hooks/useCheckScreenWidth';
import NestedRouting from './NestedRouting';
import useCheckUniversityAuthorize from 'Global/Hooks/useCheckUniversityAuthorize';
import useTest from 'Global/Hooks/useTest';
import useGetProfileImageOnMount from 'Routes/Protected/MainPage/Hooks/useGetProfileImageOnMount';
import { ImageAtom } from 'Routes/Protected/MainPage/ImageAtom';
import { useAtom } from 'jotai';

const App = () => {
  // useTest();
  const screenWidth = useCheckScreenWidth(); // 1024 for Desktop
  useCheckUniversityAuthorize();
  useCacheIcons();
  useGetMainConfig();
  const GlobalConstants = useContext(GlobalContext);
  const EntirePageRender = GlobalConstants.EntirePageRender;
  useCheckApiTokenExpiry();
  useCheckUserPrefrences();
  useCheckOnLoginOperations();

  // pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  //   "pdfjs-dist/build/pdf.worker.min.js",
  //   import.meta.url
  // ).toString();

  return (
    <React.Fragment>
      {screenWidth <= 1024 ? (
        <NormalRouting
          GlobalConstants={GlobalConstants}
          EntirePageRender={EntirePageRender}
        />
      ) : (
        <NestedRouting
          GlobalConstants={GlobalConstants}
          EntirePageRender={EntirePageRender}
        />
      )}
    </React.Fragment>
  );
};

export default App;
